export class DateTypes {
	static Today = { name: "Today", date: 0 };
	static LastSevenDays = { name: "LastSevenDays", date: -7 };
	static LastThirtyDays = { name: "LastThirtyDays", date: -30 };
	static NextSevenDays = { name: "NextSevenDays", date: 7 };
	static NextThirtyDays = { name: "NextThirtyDays", date: 30 };
}
